import React from "react";
import BalanceSheetItem from "./BalanceSheetItem";
import "./BalanceSheetStyle.css";
function BalanceSheetContainer(props) {
  let label = props.label;
  let values = 0;
  let elements = props.elements;
  for (let index = 0; index < elements.length; index++) {
    const element = elements[index];
    if (element.value !== undefined) {
      values += element.value;
    }
  }
  if (values === 0) {
    return <></>;
  }
  return (
    <>
      <tr>
        <th>{label}</th>
      </tr>
      {elements.map((e) => {
        // console.log(e.label);
        return (
          <BalanceSheetItem
            key={e.label}
            value={e.value}
            label={e.label}
            threshold={e.threshold}
          />
        );
      })}
      <BalanceSheetItem value={values} label={"Total " + label} />
    </>
  );
}

export default BalanceSheetContainer;
